export default {
  STORE_CART: "STORE_CART"
};
